<template>
    <div>
        <iframe 
            id="iframeNew" 
            class="externalFrameBot" 
            :title="title" 
            v-bind:src="src">
        </iframe>
    </div>
</template>
  
<script>

    export default {
        emits: ["messagegenericiframe"],
        props: {
            src: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            }
        },
        data() {
            return{
                x: 0
            }
        },
        
        mounted(){
            window.addEventListener('message', this.genericFrameEventListener)
        },
        created(){
            localStorage.setItem("prevErrorDescription", '');
            localStorage.setItem("prevOperationType", '');
            localStorage.setItem("prevSuccess", '');
            localStorage.setItem("prevCode",'');
        },
        beforeDestroy() {
            window.removeEventListener("message", this.genericFrameEventListener);
        },
        methods: {
            genericFrameEventListener(e){
                // Definir si el postmessage contiene una URL válida
                try {
                    if(!(typeof e.data === 'object' && e.data !== null) && e.data.includes('newTab=')){
                        const url = e.data.split('newTab=')[1];
                        console.warn("Url a dirigir:", url);
                        window.open(url, "_blank");
                    }
                } catch (error) {
                    console.error("URL inválida:", e.data);
                }
               

                if((e.data.informacionData === null || e.data.informacionData === undefined) && (typeof e.data === 'object' && e.data !== null)  ){
                    if ((e.data.ErrorDescription == localStorage.getItem('prevErrorDescription') && e.data.operationType == localStorage.getItem('prevOperationType')  && localStorage.getItem('prevSuccess') === "false") || (localStorage.getItem('prevSuccess') === "true" && e.data.code == localStorage.getItem('prevCode'))) {
                        return;
                    }
                    localStorage.setItem("prevErrorDescription", e.data.ErrorDescription); // Update variable
                    localStorage.setItem("prevOperationType", e.data.operationType);// Update variable
                    localStorage.setItem("prevSuccess", e.data.success); // Update variable
                    localStorage.setItem("prevCode", e.data.code); // Update variable
                    this.$emit('messagegenericiframe', e);
                }
            }
        }
    };
</script>